import { Pipe, PipeTransform } from '@angular/core';

import {
  instanceOfRdsDialogLink,
  instanceOfRdsTextItem,
  instanceOfRdsTextLink,
  RdsDialogLink,
  RdsTextItem,
  RdsTextLink,
} from '../core/models';

export type RdsFooterItemType = 'TEXT' | 'LINK' | 'DIALOG';

@Pipe({
  name: 'rdsAppFooterItemType',
})
export class RdsFooterItemTypePipe implements PipeTransform {
  transform(item: RdsTextItem | RdsTextLink | RdsDialogLink): RdsFooterItemType {
    if (instanceOfRdsTextLink(item)) {
      return 'LINK';
    } else if (instanceOfRdsDialogLink(item)) {
      return 'DIALOG';
    } else if (instanceOfRdsTextItem(item)) {
      return 'TEXT';
    } else {
      return null;
    }
  }
}
